
export const maskZipCode = (zip) =>{
  if (zip.length === 9) {
    return zip.replace(/(\d{5})(\d{4})/, '$1-$2');
  } else {
    return zip.slice(0, 5);
  }
}

export const MaskFormatted = (value, mask) => {
  if (value) {
    const rules = ['0', '9', '#', '&', '?', 'A', 'C', 'L', 'a'];
    let tempValue = [...value];
    let maskedValue = '';
    for (var i = 0; i < mask.length; i++) {
      let currentRule = mask[i];
      if (rules.indexOf(mask[i]) >= 0) {
        let nextChar = tempValue.shift();
        maskedValue += nextChar ? nextChar : '';
      } else {
        maskedValue += currentRule;
      }
    }
    return maskedValue;
  };

}


